import axios from 'axios';
import { Secret } from '../types/models';
import { API_BASE } from './config';

export type SecretsImportResult = {
  ok: boolean;
  count: number;
  created: number;
  updated: number;
  invalid?: { line: number; raw: string; address?: string; derived?: string; error: string }[];
};

export async function importSecrets(keypairs: string): Promise<SecretsImportResult>{
  const res = await axios.post<SecretsImportResult>(`${API_BASE}/secrets/import`, { keypairs });
  return res.data;
}

export async function getSecrets(): Promise<Secret[]> {
  try {
    const res = await axios.get<Secret[]>(`${API_BASE}/secrets`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function getSecret(address: string): Promise<Secret> {
  try {
    const res = await axios.get<Secret>(`${API_BASE}/secrets/${address}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function createSecret(secret: Partial<Secret>): Promise<Secret> {
  try {
    const res = await axios.post<Secret>(`${API_BASE}/secrets`, secret);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function updateSecret(address: string, secret: Partial<Secret>): Promise<Secret> {
  try {
    const res = await axios.put<Secret>(`${API_BASE}/secrets/${address}`, secret);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function deleteSecret(address: string): Promise<void> {
  try {
    await axios.delete(`${API_BASE}/secrets/${address}`);
  } catch (err) {
    throw err;
  }
} 